import script from "./EmployeeCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeCreate.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeCreate.vue?vue&type=style&index=0&id=5d4c1056&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d4c1056"]])

export default __exports__